module.exports = __webpack_public_path__ + "static/image_1-c3e09618c8a97cb0ae3f972d25c7d40b.svg";